// @ts-check

import React, { createContext, useContext, useState } from "react";

const SettingsContext = createContext({});

export const SettingsProvider = ({ children }) => {
  const [error, setError] = useState(null);

  return (
    <SettingsContext.Provider
      value={{
        error,
        setError,
      }}
    >
      {children}
    </SettingsContext.Provider>
  )
};

export const useSettings = () => {
  const context = useContext(SettingsContext);
  return context;
};
